module.exports = "/assets/data/050df936023e19f452938967db461dc7-BN22.data.json";